// Captured once at module load – contains the installation name set by Rails.
const BASE_TITLE = document.title;

/**
 * Sets the browser tab title.
 * Produces "{title} - {installation name}" when a title is supplied,
 * or falls back to the plain installation name when called with no argument.
 */
export const setPageTitle = (title = '') => {
  document.title = title ? `${title} - ${BASE_TITLE}` : BASE_TITLE;
};

export { BASE_TITLE };
